__turbopack_context__.v({
  "className": "noto_sans_jp_80624916-module__2Pn2vq__className",
});
